import script from "./PasesUtilizados.vue?vue&type=script&setup=true&lang=js"
export * from "./PasesUtilizados.vue?vue&type=script&setup=true&lang=js"

import "./PasesUtilizados.vue?vue&type=style&index=0&id=07eac098&lang=css"

const __exports__ = script;

export default __exports__